<template>
  <v-container
    class="page-section"
    data-aos="fade"
    v-if="event"
  >
    <v-hover
      v-if="event.image"
      :disabled="!editable"
    >
      <template v-slot:default="{ hover }">
        <v-card flat color="transparent">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col cols="12" class="text-center">
                <v-img
                  max-height="500px"
                  :lazy-src="event.image.thumbnail"
                  :src="event.image.url"
                ></v-img>
                <p
                  class="pt-3"
                  v-html="event.titleText"
                ></p>
              </v-col>
              <v-col cols="12" class="print-me">
                <h1 class="text-center">{{event.title}}</h1>
                <p class="posted-on text-center">
                  {{postedAt(event.publishedAt)}}
                </p>
              </v-col>
            </v-row>
            <v-overlay
              absolute
              opacity="0.2"
              v-if="hover"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    @click="editTitle"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-format-title</v-icon>
                  </v-btn>
                </template>
                <span>Title</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    @click="onEventAction('image')"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-image-edit</v-icon>
                  </v-btn>
                </template>
                <span>Images</span>
              </v-tooltip>
            </v-overlay>
          </v-container>
        </v-card>
      </template>
    </v-hover>
    <slot name="description"></slot>
    <template v-if="event.sections.length">
      <v-hover
        v-for="(section, index) in event.sections" :key="index"
        v-slot="{ hover }"
        :disabled="!editable"
      >
        <template v-if="!section.profiles">
          <v-card flat color="transparent" class="mb-3">
            <recipe-section
              :editable="hover"
              :header="section.header"
              :headerColor="section.headerColor"
              :index="index"
              :link="section.link"
              :linkText="section.linkText"
              :linkColor="section.linkColor"
              :section="section"
              @action="onAction"
            >
              <template v-if="section.type === 'split'">
                <v-row class="print-me">
                  <v-col
                    cols="12"
                    sm="4"
                    data-aos="fade"
                  >
                    <h6>{{section.left.heading}}</h6>
                    <p v-html="section.left.content"></p>
                  </v-col>
                  <v-col
                    class="pl-sm-8"
                    cols="12"
                    sm="8"
                    data-aos="fade"
                  >
                    <h6>{{section.right.heading}}</h6>
                    <p v-html="section.right.content"></p>
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <v-row>
                  <v-col cols="12"
                    color="transparent"
                    flat
                    v-if="section.content"
                    v-html="section.content">
                  </v-col>
                </v-row>
              </template>
            </recipe-section>
          </v-card>
        </template>
      </v-hover>
    </template>
    <slot name="footer"></slot>
  </v-container>
</template>

<script>
import RecipeSection from '@/components/RecipeSection'
import MetaInfoBuilder from '@/utils/social'
import {
  VBtn,
  VCard,
  VCol,
  VContainer,
  VHover,
  VIcon,
  VImg,
  VOverlay,
  VRow,
  VTooltip,
} from 'vuetify/lib'
import moment from 'moment'

export default {
  components: {
    RecipeSection,
    VBtn,
    VCard,
    VCol,
    VContainer,
    VHover,
    VIcon,
    VImg,
    VOverlay,
    VRow,
    VTooltip,
  },
  data: () => ({
    tags: ['one', 'two'],
  }),
  metaInfo() {
    if (this.event) {
      return new MetaInfoBuilder()
        .description(this.event.description)
        .image(this.event.image.url)
        .title(this.event.title)
        .build()
    }
  },
  methods: {
    editTitle() {
      this.$emit('title')
    },
    onAction(action) {
      this.$emit('sectionAction', action)
    },
    onEventAction(action) {
      this.$emit('eventAction', action)
    },
    postedAt(timestamp) {
      if (!timestamp) {
        return 'Not published yet'
      }

      const postedAt = moment(timestamp.toDate()).format('DD MMM YYYY')

      return `Posted on ${postedAt}`
    },
    onSearchTags() {},
  },
  props: {
    editable: {
      default: false,
      type: Boolean,
    },
    event: Object,
    subtitles: Array,
  }
}
</script>

<style lang="scss" scoped>
.editable {
  // border: 1px black solid;
  background: rgba($color: #000000, $alpha: .5) !important;
}

.event-title {
  color: white;
  font-size: 35px !important;
  // text-shadow: 0 0 5px black;
  text-transform: uppercase;
  word-break: normal;
}

.event-title-sm {
  color: white;
  font-size: 28px !important;
  // text-shadow: 0 0 5px black;
  text-transform: uppercase;
  word-break: normal;
}

h1 {
  color: rgba(0, 0, 0, 0.87);
  font-family: 'Nanum Myeongjo', serif !important;
  font-size: 60px !important;
}

.page-section {

  font-size: 15px;

  h6 {
    border: 1px solid;
    display: inline-block;
    font-size: 12px;
    font-weight: normal;
    padding: 6px 18px;
    margin-bottom: 20px;
    text-transform: uppercase;
    word-break: normal;
  }

  .posted-on {
    font-size: 12px;
    // text-transform: uppercase;
  }

  .posted-under {
    font-size: 15px;
    list-style: none;
    padding: 0;

    li:first-child {
      color: gray;
    }

    li {
      display: inline-block;
      margin: 5px;
    }
  }
}
</style>
